import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type SizeSettingSetResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateSizeSetsListKey } from '../usePrivateSizeSetsList';

export type UsePrivateSizeSetsUpdateMutationParams = NonNullable<Parameters<typeof SizeSettings.Sets.update>[0]>;

export const usePrivateSizeSetsUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateSizeSetsUpdateMutationParams) => {
      return callAirApi<SizeSettingSetResponse>(() => SizeSettings.Sets.update(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        context: 'Failed to update size set',
        error,
        metadata: {
          data: variables,
          key: 'data',
        },
      });
    },

    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getPrivateSizeSetsListKey({ workspaceId: variables.workspaceId }),
      });
    },
  });
};
